export type RunPhase = "idle" | "submitting" | "running";

interface RunningIndicatorProps {
    phase: RunPhase;
}

export function RunningIndicator({ phase }: RunningIndicatorProps) {
    if (phase === "idle") return null;

    return (
        <div className="mt-8 p-4 border border-quantum-500/30 bg-quantum-500/10 rounded-lg text-center">
            <div className="animate-pulse flex flex-col items-center justify-center">
                <svg
                    className="animate-spin h-8 w-8 text-quantum-400 mb-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                </svg>
                {phase === "submitting" && (
                    <p className="text-quantum-400 font-medium">Submitting project…</p>
                )}
                {phase === "running" && (
                    <p className="text-quantum-400 font-medium">Model running – this may take several minutes…</p>
                )}
            </div>
        </div>
    );
}